import { API } from '../../helpers';
export const yuan = (units = 0) => `¥${(units / 1000000).toFixed(6).replace(/0+$/, '').replace(/\.$/, '.00')}`;
export const units = (value) => {
  const text = String(value).trim();
  if (!/^\d{1,7}(\.\d{1,6})?$/.test(text)) throw new Error('金额须为非负数，最多六位小数');
  const [whole, fraction = ''] = text.split('.');
  const result = Number(whole) * 1000000 + Number(fraction.padEnd(6, '0'));
  if (!Number.isSafeInteger(result) || result > 1000000000000) throw new Error('金额超出范围');
  return result;
};
export async function request(method, path, data) {
  const result = await API.request({ method, url: path, data });
  if (!result.data.success) throw new Error(result.data.message || '操作失败');
  return result.data.data;
}
export const time = (stamp) => stamp ? new Date(stamp * 1000).toLocaleString('zh-CN') : '—';
export const states = { reserved: '处理中', pending: '待核算', settled: '已结算', released: '已释放' };
